export const Mail = (props) => (
<svg  {...props} width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g  transform="translate(-462.000000, -1774.000000)">
            <g transform="translate(462.535714, 1774.750000)">
                <circle stroke="#E6E6E6" stroke-width="0.5" cx="16.5" cy="16.5" r="16.25"></circle>
                <g transform="translate(8.374989, 10.000000)" fill="currentColor" fill-rule="nonzero">
                    <path d="M14.6250108,3.25 L8.12501082,7.31250542 L1.62498918,3.25 L1.62498918,1.62498918 L8.12501082,5.6874946 L14.6250108,1.62498918 L14.6250108,3.25 Z M14.6250108,0 L1.62498918,0 C0.731228924,0 0,0.731250533 0,1.62498918 L0,11.3750108 C0,12.2687711 0.731250533,13 1.62498918,13 L14.6250108,13 C15.5187711,13 16.2500216,12.2687495 16.2500216,11.3750108 L16.2500216,1.62498918 C16.2500216,0.731250533 15.5187495,0 14.6250108,0 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>);